<template>
  <v-container>
    <v-row justify="space-between" align="center" class="mb-1">
      <v-col cols="auto">
        <v-btn color="success" @click="handleOpenForm" rounded>Añadir Informacion</v-btn>
      </v-col>
      <v-col cols="12" md="auto">
        <v-text-field
          filled
          rounded
          dense
          v-model="searchQuery"
          append-icon="mdi-magnify"
          label="Buscar"
          single-line
          hide-details
        ></v-text-field>
      </v-col>
    </v-row>
    <v-card class="shadow-1">
      <v-card flat>
        <!-- Tabla -->
        <v-container v-if="!isOpenGraph">
          <vuescroll
            :ops="{
              bar: {
                background: '#bacfcec0',
                keepShow: true,
              },
            }"
          >
            <v-data-table
              :headers="clientsHeaders"
              :items="FilteredList"
              class="elevation-0"
              :loading="isLoading"
              :server-items-length="totalItems"
              :options.sync="tableOptions"
              :footer-props="{ 'items-per-page-options': [15, 30, 50, 100] }"
            >
              <template v-slot:[`item.service.service_type`]="{ item }">
                {{
                  serviceTypeList.find((el) => el.id === item.service.service_type)
                    ? serviceTypeList.find((el) => el.id === item.service.service_type).name
                    : ""
                }}
              </template>
              <template v-slot:[`item.action`]="{ item }">
                <v-hover v-slot:default="{ hover }">
                  <v-btn text icon :color="hover ? 'accent' : 'blue-grey'" @click.stop="handleEdit(item)">
                    <v-icon>mdi-pencil</v-icon>
                  </v-btn>
                </v-hover>
              </template>
            </v-data-table>
          </vuescroll>
        </v-container>
      </v-card>
    </v-card>
    <client-information-dialog :open="isOpenedForm" @dialog:close="handleCloseForm" :dataToEdit="dataToEdit">
    </client-information-dialog>
  </v-container>
</template>

<script>
import vuescroll from "vuescroll";
import ClientInformationDialog from "@/components/ClientInformation/ClientInformationDialog.vue";
import { serviceTypeList } from "@/components/ClientInformation/utils";
import { PbxHttpClient } from "@/services";
export default {
  components: { vuescroll, ClientInformationDialog },

  data() {
    return {
      serviceTypeList,
      autoIncrement: 0,
      isLoading: false,
      isOpenedForm: false,
      searchQuery: "",
      totalItems: 0,
      tableOptions: {},
      clientsHeaders: [
        { text: "Nombre del Cliente", value: "name", width: "20%" },
        { text: "Tipo de servicio", value: "doc_service_id", width: "15%" },
        { text: "Cantidad de extensiones", value: "extensions_count", width: "18%" },
        { text: "Colas", value: "queues_count", width: "15%" },
        { text: "Cantidad de Agentes", value: "agents_count", width: "20%" },
        { text: "Acciones", value: "action", width: "10%" },
      ],
      list: [],
      dataToEdit: {},
    };
  },

  computed: {
    isMobile() {
      return this.$vuetify.breakpoint.mobile;
    },
    isDark() {
      return this.$vuetify.theme.dark;
    },
    FilteredList() {
      return this.searchQuery.length
        ? this.list.filter((el) => this.searchQuery.toLowerCase().includes(el.client.name.toLowerCase()))
        : this.list;
    },
  },

  watch: {
    tableOptions: {
      deep: true,
      handler() {
        this.getList();
      },
    },
  },

  // created() {
  //   this.getList();
  // },

  methods: {
    handleOpenForm() {
      this.isOpenedForm = true;
    },
    handleCloseForm(data = null) {
      this.isOpenedForm = false;
      if (data) {
        if (this.dataToEdit) this.list = this.list.map((el) => (el.id === data.id ? data : el));
        else this.list = [...this.list, data];
        this.$snotify.success("Informacion guardada", "¡Hecho!");
      }
    },
    handleEdit(item) {
      this.dataToEdit = item;
      this.handleOpenForm();
    },
    async getList() {
      this.isLoading = true;
      try {
        const { page, itemsPerPage } = this.tableOptions;
        const { data } = await PbxHttpClient.get("/doc-clients", {
          params: { page, itemPerPage: itemsPerPage },
        });
        this.list = data.data;
        this.totalItems = data.total;
      } catch (error) {
        console.log("error getting client information", error);
      }
      this.isLoading = false;
    },
  },
};
</script>

<style>
.flip-icon {
  -moz-transform: scaleX(-1);
  -o-transform: scaleX(-1);
  -webkit-transform: scaleX(-1);
  transform: scaleX(-1);
}
</style>
